export default {
  ADMIN: 'admin',
  APPRENTICE_LEADER: 'apprentice-leader',
  INSTRUCTOR: 'instructor',
  APPRENTICE: 'apprentice',
  HR: 'hr',
  TRAINING_OFFICER: 'training-officer'
};
